import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/malwareSlice";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetMalwareQuery } from "../services/malware.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import Filter from "./Filter/Filter";
import MalwareDetails from "./malwareDetails/MalwareDetails";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "threat_name",
        label: "Threat name",
        sortProperty: "threat_name",
        sortId: "malware-sort-threat-name",
        width: "350px",
    },
    {
        id: "file_name",
        label: "File name",
        sortProperty: "file_name",
        sortId: "malware-sort-file-name",
        width: "100%",
    },
    {
        id: "reviewed",
        label: "Analyst-Vetted",
        sortProperty: "reviewed",
        sortId: "malware-sort-reviewed",
        width: "160px",
    },
    {
        id: "violations_count",
        label: "# Issues",
        sortProperty: "violations_count",
        sortId: "malware-sort-violations",
        width: "120px",
    },
];
const MalwareContent = () => {
    var _a, _b;
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { malware: [], match_count: 0 }, isLoading, isFetching, isError, error, } = useGetMalwareQuery({
        ui_id: reportId,
        filter,
        sort,
        pagination,
    });
    const handleSortChange = (newSort) => dispatch(sortUpdated(newSort));
    const totalMalware = (_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.malware.total_threats) !== null && _a !== void 0 ? _a : 0;
    const triagedMalware = (_b = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.malware.overridden) !== null && _b !== void 0 ? _b : 0;
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Malware", details: [
                formatCount(totalMalware, "Detected threat"),
                triagedMalware > 0 && `${triagedMalware.toLocaleString()} Triaged`,
            ] }),
        React.createElement(Page.Filters, { found: {
                id: "malware-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "malware",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "malware-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.malware.map((malwareInfo, index) => (React.createElement(MalwareDetails, { key: malwareInfo.threat_details.uuid, index: index, malware: malwareInfo })))))));
};
const Malware = () => {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(MalwareContent, null)));
};
export default Malware;
//# sourceMappingURL=Malware.js.map